import { render, staticRenderFns } from "./InputBirthDay.vue?vue&type=template&id=56f91b4d&scoped=true&"
import script from "./InputBirthDay.vue?vue&type=script&lang=js&"
export * from "./InputBirthDay.vue?vue&type=script&lang=js&"
import style0 from "./InputBirthDay.vue?vue&type=style&index=0&id=56f91b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f91b4d",
  null
  
)

export default component.exports